import { type Experiments } from '@wix/yoshi-flow-editor';

export const FEATURE_TOGGLES = {
  initFormControllerWithTimeout: 'initFormControllerWithTimeout',
} as const;

/**
 * Hotfix until `@wix/wix-experiments` is updated to 3.2.35 or later in viewer-platform,
 * that supports value `"B"` as true.
 */
export const isFeatureEnabled = (
  experiments: Experiments,
  key: (typeof FEATURE_TOGGLES)[keyof typeof FEATURE_TOGGLES],
): boolean => experiments.get(key) === 'B' || experiments.enabled(key);
